import React, { useRef, useState, useCallback, useMemo } from 'react';
import { Modal } from 'bootstrap';

const MODAL_TYPES = {
  EMAIL: 'email',
  OTP: 'otp',
  PROFILE: 'profile'
};

const useModalManager = () => {
  const emailModalRef = useRef(null);
  const otpModalRef = useRef(null);
  const profileModalRef = useRef(null);
  
  const [currentModal, setCurrentModal] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const modalRefs = useMemo(() => ({
    [MODAL_TYPES.EMAIL]: emailModalRef,
    [MODAL_TYPES.OTP]: otpModalRef,
    [MODAL_TYPES.PROFILE]: profileModalRef
  }), []);

  const closeAllModals = useCallback(() => {
    
    Object.values(modalRefs).forEach(ref => {
      if (ref.current) {
        const modalInstance = Modal.getInstance(ref.current);
        if (modalInstance) {
          modalInstance.hide();
        }
      }
    });
    
    // Remove any lingering backdrops
    document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
      backdrop.remove();
    });
    
    // Remove modal-open class from body
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    
    setCurrentModal(null);
  }, [modalRefs]);

  const openModal = useCallback((modalType) => {
    closeAllModals();
    
    setTimeout(() => {
      const modalRef = modalRefs[modalType];
      if (modalRef?.current) {
        const modal = Modal.getOrCreateInstance(modalRef.current);
        modal.show();
        setCurrentModal(modalType);
      }
    }, 300); // Increased timeout to ensure backdrop is fully removed
  }, [modalRefs, closeAllModals]);

  return {
    modalRefs,
    currentModal,
    userEmail,
    setUserEmail,
    isLoading,
    setIsLoading,
    openModal,
    closeAllModals
  };
};

export default useModalManager;
